const { privateApi } = require("../../../api");

const getUsersListForMultiSelect = async (companyId, onlySelectedCompanyUser) => {
    const pathWithQuery = `users/getUsersListForAsyncTypeSearch/?companyId=${companyId}&onlySelectedCompanyUser=${onlySelectedCompanyUser|| false}`
    return await privateApi.get(pathWithQuery);
};

export default {
    getUsersListForMultiSelect,
};